import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, setUserId, Analytics } from 'firebase/analytics';
import { FIREBASE_CONFIG } from '../config';

let app: FirebaseApp | null = null;
let analytics: Analytics | null = null;
let initPromise: Promise<Analytics | null> | null = null;

async function ensureAnalytics(): Promise<Analytics | null> {
  if (analytics) return analytics;
  if (initPromise) return initPromise;

  initPromise = (async () => {
    if (!FIREBASE_CONFIG.measurementId || !FIREBASE_CONFIG.projectId) return null;
    if (!(await isSupported().catch(() => false))) return null;
    if (!app) app = getApps()[0] ?? initializeApp(FIREBASE_CONFIG);
    analytics = getAnalytics(app);
    return analytics;
  })();

  return initPromise;
}

export async function initAnalytics(): Promise<void> {
  await ensureAnalytics();
}

export async function trackEvent(name: string, params?: Record<string, any>): Promise<void> {
  const a = await ensureAnalytics();
  if (!a) return;
  logEvent(a, name as any, params);
}

export async function identifyUser(userId: string | null): Promise<void> {
  const a = await ensureAnalytics();
  if (!a) return;
  setUserId(a, userId ?? null as any);
}
